// Const
import { DEVICE_TYPE, DEVICE_ATTR } from "const";

export const columnVisibilityDefinitionSwitch = [
  {
    groupNames: ["Status"],
    columns: {
      Status: [
        "portIndex",
        "modelName",
      ],
    },
  },
  {
    groupNames: ["Settings", ""],
    columns: {
      Settings: [
        "portName",
        "portProfile",
        "linkSpeed",
        "portType",
        "operation",
        "PVID",
        "allowVlan",
        "RSTP",
        "LBD",
        "DDP",
        "stpGuard",
      ],
    },
  },
  {
    groupNames: [""],
    hideGroupName: true,
    columns: {
      "": [
        "portSchedule",
        "poeSchedule",
        "accessPolicies",
        "portTags",
      ],
    },
  },
];

export const columnVisibilityDefinitionAP = [
  {
    groupNames: ["Status"],
    columns: {
      Status: [
        "portIndex",
        "modelName",
      ],
    },
  },
  {
    groupNames: ["Settings"],
    columns: {
      Settings: [
        "portProfile",
        "PVID",
        "allowVlan",
        "portTags",
      ],
    },
  },
];

export const columnVisibilityDefinition = columnVisibilityDefinitionSwitch;

export const defaultCategories = [
  { value: null, label: "Category", isSelected: true }, // default option.
  { value: DEVICE_ATTR.types.AP, label: DEVICE_TYPE.ap, isSelected: false },
  { value: DEVICE_ATTR.types.SW, label: DEVICE_TYPE.switch, isSelected: false },
]

export const defaultModels = [
  {
    value: null,
    label: "Selected Model",
    isSelected: true,
    deviceCategory: null,
    seriesName: null,
    truncatedHWVer: null,
    truncatedHWVerWithSuffix: null,
    isDefault: true,
  }
]

export const defaultLinkSpeedDefinitions = {
  "auto": { label: "Auto", value: "auto" },
  "100G_full": { label: "100 Gbps Full Duplex", value: "100G_full" },
  "40G_full": { label: "40 Gbps Full Duplex", value: "40G_full" },
  "25G_full": { label: "25 Gbps Full Duplex", value: "25G_full" },
  "10G_full": { label: "10 Gbps Full Duplex", value: "10G_full" },
  "5G_full": { label: "5 Gbps Full Duplex", value: "5G_full" },
  "2.5G_full": { label: "2.5 Gbps Full Duplex", value: "2.5G_full" },
  "1G_full": { label: "1 Gbps Full Duplex", value: "1G_full" },
  "10M_full": { label: "10 Mbps Full Duplex", value: "10M_full" },
  "100M_full": { label: "100 Mbps Full Duplex", value: "100M_full" },
  "100M_half": { label: "100 Mbps Half Duplex", value: "100M_half" },
}